export const clearStaleCache = () => {
  // Versioning compliant with the new deployment
  const CURRENT_VERSION = 'v5_crash_protection_fix';
  const storedVersion = localStorage.getItem('app_version');

  if (storedVersion !== CURRENT_VERSION) {
    console.log('🔄 Detected new version. Clearing old caches and service workers...');

    // 1. Unregister all Service Workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.unregister().then(() => console.log('Service Worker unregistered'));
        }
      });
    }

    // 2. Delete all Cache Storage
    if ('caches' in window) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name).then(() => console.log(`Cache deleted: ${name}`));
        }
      });
    }

    // 3. Update version
    localStorage.setItem('app_version', CURRENT_VERSION);

    // 4. Force Reload (Optional, maybe specific to user flow)
    console.log('✅ Cache cleared. App is fresh.');
  }
};
